export const environment = {
  name: 'develop',
  production: false,
  serverAddress: 'https://dev-sped.spedautomation.com.br',
  editorUrl: "https://dev-editorsped.spedautomation.com.br/EditorSPED.App",
  editorApiUrl: "https://dev-editorsped.spedautomation.com.br",
  amplitudeApiKey: "da8f33a0ff82afb70a6da32db2e1ef26",
};
